import {checkMethod} from '../../utils/validate';
import {debug} from '../../config';
// import {pApiKey, debug} from '../../config';

/* eslint-disable require-jsdoc */;
function getAjaxOpts(hearbyApiKey, url, method, auth) {
  const opts = {};
  opts.url = url;
  const httpMethod = checkMethod(method);
  if (httpMethod == 'method issue') {
    return httpMethod;
  }
  opts.method = httpMethod;
  if (auth) {
    opts.headers = {
      'Authorization': 'Bearer ' + hearbyApiKey,
    };
  }
  debug && console.log('ajax opts ', opts);
  return opts;
}
export {getAjaxOpts};
